import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { mountHollyConfig } from "./data";

export default function MountHollyPage() {
  return <CityPageTemplate config={mountHollyConfig} />;
}